<template lang="pug">
	.reading-rate-editor.flex-col.space-large
		.flex-col.space
			.font-small.upper.grey {{$tCaption('Predefined')}}
			.flex-row.space
				DxButton(v-for="pred in readingRates", :key="pred.id", :text="pred.name", :type="predefinedValue === pred.id ? 'default' : 'normal'", @click="() => onPredefinedSet(pred)")
		.flex-col
			.flex-row.font-small.upper.grey.space
				span {{$tCaption('Custom')}} 
				span(v-if="!predefinedValue && numberValue !== 1") {{$formatNumber(numberValue, 1).replace(',', '.')}}
			.flex-row.space
				DxSlider.flex-1(:min="0", :max="3", :step="0.1", :value.sync="numberValue", :show-range="false")
</template>

<script>
	import DxButton from 'devextreme-vue/button';
	import DxSlider from 'devextreme-vue/slider';

	export default {
		translationCategory: 'insertion.SSMLReadingRateEditor',
		name: 'reading-rate-editor',
		components: {
			DxButton, 
			DxSlider
		},
		model: {
			prop: 'value',
			event: 'change '
		},
		props: ['text', 'value'],
		data() {
			var readingRates = [
				{ id: 'x-slow', name: this.$tCaption('Extra slow') },
				{ id: 'slow', name: this.$tCaption('Slow') },
				{ id: 'medium', name: this.$tCaption('Medium') },
				{ id: 'fast', name: this.$tCaption('Fast') },
				{ id: 'x-fast', name: this.$tCaption('Extra fast') },
			];
			return {
				predefinedValue: readingRates.filter(f => f.id === this.value)[0]?.id,
				numberValue: parseFloat(this.value) || 1,
				readingRates
			};
		},		
		watch: {
			numberValue(v) {
				if (v) {
					this.predefinedValue = null;
					this.$emit('change', this.numberValue);
				}
			}
		},
		mounted() {
			if (__DEBUG__)
				window.readingRateEditor = this;
		},
		methods: {
			onPredefinedSet(pred) {
				this.predefinedValue = pred.id;
				this.$emit('change', pred.id);
			}
		}
	};
</script>
<style lang='scss'>
	.reading-rate-editor {

	}
</style>
